import { AssetState, AssetTier } from '@optools/services/operator-gateway/types/generated/graphql';
import { z } from 'zod';

export const bulkAssetUpdateFormSchema = z.object({
  assetState: z.enum(AssetState),
  provider: z.literal('AWS').or(z.literal('GCP')).or(z.literal('ALL')),
  tier: z.enum(AssetTier).or(z.literal('ALL')),
});

export type BulkAssetUpdateFormValues = z.infer<typeof bulkAssetUpdateFormSchema>;
